import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import Vuex from 'vuex'
import Vue from 'vue'


export const oidcSettings = {
      // "acr_values" : "tenant: isOTPLogin:false",//+ tenant,
      "authority":"https://apiv2.trackervigil.com",
      // "authority": 'https://localhost:5002', 
      //"authority": 'https://nvg-identityserver.conveyor.cloud/', 
      // "authority":'https://api.testtracker.xyz/identity',
      //"client_id":"vts-mobile.app",
      // "client_id":"new.client.app",
      //  "client_id": "localhost.app",
      //  "client_secret":"ea6a4bce-64f9-4d48-b4c0-fd79f7f2df95",
      //"authority":"https://api.novigodemo.com",
      //  "authority":"http://identityapi.novigodemo.com",
      //"authority":"https://api.vts-dev.xyz/identity",
      "client_id": "novigoidentityportal.app",//"localhost.app", //"novigoidentityportal.app", //"ETMS.app", 
      "client_secret": "a2cc8529-889a-48b0-af66-a145423ed572",//"0b4168e4-2832-48ea-8fc8-7e4686b3620b",
      //"redirect_uri": "http://identitymanager.novigodemo.com/callback",
      "redirect_uri": window.location.origin+"/callback",//window.location.origin+"/callback", //"http://localhost:8080/callback",
      "client_name":"Vue JS APP for novigi portal",
      "grant_type": "authorization_code",
      "response_type": "code",
      "scope": "openid profile",
      //"post_logout_redirect_uri": "http://identitymanager.novigodemo.com/logoutSuccess",
      //"silent_redirect_uri": 'http://identitymanager.novigodemo.com/silent-renew-oidc',//'http://identity.novigodemo.com/silent-renew-oidc',
       "post_logout_redirect_uri": window.location.origin+"/logoutSuccess",
       "silent_redirect_uri": window.location.origin+'/silent-renew-oidc',//'http://identity.novigodemo.com/silent-renew-oidc',
      "automaticSilentRenew": true,
  }
  Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    oidcStore: vuexOidcCreateStoreModule(
      oidcSettings,
      // NOTE: If you do not want to use localStorage for tokens, in stead of just passing oidcSettings, you can
      // spread your oidcSettings and define a userStore of your choice
      // {
      //   ...oidcSettings,
      //   userStore: new WebStorageStateStore({ store: window.sessionStorage })
      // },
      // Optional OIDC store settings
      // Optional OIDC event listeners
      {
        userLoaded: (user) => console.log('OIDC user is loaded:', user),
        userUnloaded: () => console.log('OIDC user is unloaded'),
        accessTokenExpiring: () => console.log('Access token will expire'),
        accessTokenExpired: () => console.log('Access token did expire'),
        silentRenewError: () => console.log('OIDC user is unloaded'),
        userSignedOut: () => console.log('OIDC user is signed out'),
        oidcError: (payload) => console.log('OIDC error', payload),
        automaticSilentRenewError: (payload) => console.log('OIDC automaticSilentRenewError', payload)
      }
    )
  }
})